import React from "react";

import { Grid } from "@material-ui/core";

import { Input } from "components/Form/FormikControls";

import { CriteriaForm } from "containers/Settings/RuleBooks/Rules/CustomRules/Criteria/CriteriaForm";

interface RuleSetSummaryFormProps {
  isManagedRule: boolean;
}

export const RuleSetSummaryForm = ({
  isManagedRule,
}: RuleSetSummaryFormProps) => (
  <Grid container>
    <Grid item xs={12}>
      <Input label="Name" name="name" required />
    </Grid>
    <Grid item xs={12}>
      <CriteriaForm
        parentInputPath={null}
        hasPrerequisiteRule={false}
        readOnly={isManagedRule}
      />
    </Grid>
  </Grid>
);
